import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import Sparkles from 'src/assets/svgs/Sparkles.svg'
import Box from 'src/components/Box/Box'
import SvgCloseLoD from 'src/components/Svgs/SvgCloseLoD'
import { css, CSSProp } from 'styled-components'

interface SpotlightProps {
  className?: string
  imageSrc?: string
  title?: React.ReactElement
  subtitle: React.ReactElement
  badge?: React.ReactElement
  tooltip?: boolean
  tooltipDown?: boolean
  tooltipRight?: boolean
  tooltipLeft?: boolean
  smallerText?: boolean
  cookieFunction: (value: boolean) => void
}

const Spotlight: React.FC<SpotlightProps> = (props): React.ReactElement => {
  const tooltipStyling: CSSProp = css`
    position: absolute;
    width: 0;
    height: 0;
    border-width: 10px;
    border-style: solid;
  `

  return (
    <Box
      className={props.className}
      noPadding
      css={css`
        background-color: ${styleConstants.colors.purple};
        transition: box-shadow ${styleConstants.transitionSpeed.fastest}
          ease-out;
        padding: ${styleConstants.heights.minorInternalGutter}
          ${styleConstants.widths.cardPaddingXXSMOnly};

        &:hover {
          box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.15);
        }

        ${getBreakpointDown(breakpointSizes.XSM)(css`
          margin-left: 5px;
          margin-right: 5px;
        `)}
      `}
    >
      {props.badge && (
        <Box
          noPadding
          css={css`
            position: absolute;
            top: -20px;
            left: 15px;
            background-color: ${styleConstants.colors.yellow};
            padding: 7px;

            ${getBreakpointDown(breakpointSizes.XSM)(css`
              top: -10px;
              padding-top: 2px;
              padding-bottom: 2px;
              padding-left: 7px;
              padding-right: 7px;
            `)}
          `}
        >
          <span
            css={css`
              color: ${styleConstants.colors.purple};

              ${getBreakpointDown(breakpointSizes.XSM)(css`
                ${getFontCss(
                  10,
                  styleConstants.colors.white,
                  styleConstants.fontFamilies.regular,
                )}
                color: ${styleConstants.colors.purple};
              `)}
            `}
          >
            {props.badge}
          </span>
        </Box>
      )}
      {props.tooltip && (
        <div
          className={'tooltip'}
          css={css`
            ${tooltipStyling}
            top: -20px;
            left: 25px;
            border-color: transparent transparent
              ${styleConstants.colors.purple} transparent;
          `}
        />
      )}
      {props.tooltipDown && (
        <div
          className={'tooltipDown'}
          css={css`
            ${tooltipStyling}
            bottom: -20px;
            left: 25px;
            border-color: ${styleConstants.colors.purple} transparent
              transparent transparent;
          `}
        />
      )}
      {props.tooltipRight && (
        <div
          className={'tooltipRight'}
          css={css`
            ${tooltipStyling}
            top: 25px;
            right: -20px;
            border-color: transparent transparent transparent
              ${styleConstants.colors.purple};
          `}
        />
      )}
      {props.tooltipLeft && (
        <div
          className={'tooltipLeft'}
          css={css`
            ${tooltipStyling}
            top: 25px;
            left: -20px;
            border-color: transparent ${styleConstants.colors.purple}
              transparent transparent;
          `}
        />
      )}
      <div
        css={css`
          display: flex;
          align-items: center;
          color: ${styleConstants.colors.white};
        `}
      >
        <img
          src={props.imageSrc || Sparkles}
          alt={'new feature'}
          css={css`
            align-self: flex-start;
            transform-origin: top;

            ${getBreakpointDown(breakpointSizes.XSM)(css`
              transform: scale(calc(24 / 24));
            `)}
          `}
        />
        <div
          css={css`
            display: flex;
            flex-direction: column;
            margin-left: 5%;
            overflow: hidden;
            word-wrap: break-word;
            position: relative;
            margin-right: 10px;

            ${getBreakpointDown(breakpointSizes.XSM)(css`
              margin-left: 16px;
            `)}
          `}
        >
          {props.title && (
            <p
              css={css`
                ${getFontCss(
                  16,
                  styleConstants.colors.white,
                  styleConstants.fontFamilies.medium,
                )}
                display: flex;
                align-items: center;
                margin-bottom: 11px;
                word-break: break-word;
                white-space: normal;

                ${getBreakpointDown(breakpointSizes.XSM)(css`
                  ${getFontCss(
                    12,
                    styleConstants.colors.white,
                    styleConstants.fontFamilies.medium,
                  )}
                `)}

                ${!!props.smallerText &&
                css`
                  ${getFontCss(
                    12,
                    styleConstants.colors.white,
                    styleConstants.fontFamilies.medium,
                  )}
                  margin-bottom: 0px;
                `}
              `}
            >
              {props.title}
            </p>
          )}
          <p
            css={css`
              ${getFontCss(
                14,
                styleConstants.colors.white,
                styleConstants.fontFamilies.regular,
              )}
              position: relative;
              word-break: break-word;
              white-space: normal;
              text-align: left;

              ${getBreakpointDown(breakpointSizes.XSM)(css`
                ${getFontCss(
                  12,
                  styleConstants.colors.white,
                  styleConstants.fontFamilies.regular,
                )}
              `)}

              ${!!props.smallerText &&
              css`
                ${getFontCss(
                  12,
                  styleConstants.colors.white,
                  styleConstants.fontFamilies.regular,
                )}
              `}
            `}
          >
            {props.subtitle}
          </p>
        </div>
      </div>
      <SvgCloseLoD
        onClick={(e): void => {
          e.preventDefault()
          props.cookieFunction(false)
        }}
        id="spotlightClose"
        css={css`
          z-index: 7;
          position: absolute;
          top: -5px;
          right: 5px;
          transform: scale(calc(15 / 24));
          transform-origin: right;
          cursor: pointer;

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            transform: scale(calc(11 / 24));
            right: 10px;
          `)}
        `}
      />
    </Box>
  )
}

export default Spotlight
